import styled, { css } from "styled-components";

export const FullScreenModalStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0; 
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 9999;
  padding: 20px; 
  box-sizing: border-box; 

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    color: white;
    .name {
        font-size: 14px;
        font-weight: 600;
    }
    .buttons {
        display: flex;
        gap: 10px;
    }
  }

  .body {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  img {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;
